import React from "react";

export default function C_V_YEAR({ value }) {
  if (!value) return null;

  return (
    <span
      title={value}
      style={{
        display: "block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%",
        lineHeight: "1.5",
        textAlign: "right",
        paddingRight: "8px",
        boxSizing: "border-box",
      }}
    >
      {value}
    </span>
  );
}
